import React from 'react';

const Card = ({ children, ...rest }) => (
  <div className="rounded-lg shadow-lg bg-white">{children}</div>
);

export default Card;
